import { rollbar } from 'shared/services/rollbar'
import { PostInterface } from 'modules/community/types/post-interface'
import { PostPinnedToType } from 'modules/community/types/post-pinned-to-type'

export const mutatePostsByPin =
  ({
    post,
    shouldRemove,
    shouldAppend,
    modifier,
  }: {
    post: PostInterface
    shouldRemove?: boolean
    shouldAppend?: boolean
    modifier: (pinnedTo: PostPinnedToType[]) => PostPinnedToType[]
  }) =>
  (posts?: PostInterface[]) => {
    if (!posts) return
    if (!post.publishedAt) {
      rollbar.error('Pinnable post has no publishedAt', { post })
      return posts
    }

    if (shouldRemove) {
      return posts.filter(p => p.id !== post.id)
    }

    if (shouldAppend) {
      return posts.concat({ ...post, pinnedTo: modifier(post.pinnedTo) }).sort((a, b) => {
        if (!a.publishedAt || !b.publishedAt) {
          rollbar.error('Pinned post has no publishedAt', { post: a, post2: b })
          return 0
        }
        return new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime()
      })
    }

    return posts.map(p => (p.id === post.id ? { ...p, pinnedTo: modifier(p.pinnedTo) } : p))
  }
